module.exports = __webpack_public_path__ + "img/web-grey-icon.1ccb51ee.svg";